import { render, staticRenderFns } from "./ManagerSuspendedGuard.vue?vue&type=template&id=0bb6e853"
import script from "./ManagerSuspendedGuard.vue?vue&type=script&lang=ts"
export * from "./ManagerSuspendedGuard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb6e853')) {
      api.createRecord('0bb6e853', component.options)
    } else {
      api.reload('0bb6e853', component.options)
    }
    module.hot.accept("./ManagerSuspendedGuard.vue?vue&type=template&id=0bb6e853", function () {
      api.rerender('0bb6e853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/guards/ManagerSuspendedGuard.vue"
export default component.exports